import React from 'react'

export default props => (
  <svg viewBox="0 0 14 14" {...props} className="icon-add fill-white">
    <polygon points="14 8 8 8 8 14 6 14 6 8 0 8 0 6 6 6 6 0 8 0 8 6 14 6" />
  </svg>
)
